// @flow
import * as React from 'react';
import Checkboxes from 'components/Checkboxes';
import Field from './Field';

const { useMemo } = React;

const MultiCheckboxField = ({
  name,
  label,
  description,
  large,
  ...props
}: {
  name: string,
  label?: React.Node,
  description?: string,
  options: Array<{ label: string, name: string }>,
  large?: boolean
}) => {
  const update = useMemo(
    () => ({ value = [], option, updateValue }) => {
      const newValue = value.includes(option)
        ? value.filter(o => o !== option)
        : [...value, option];
      updateValue(newValue);
    },
    []
  );
  return (
    <Field
      inputProps={props}
      name={name}
      label={label}
      description={description}
      renderInput={({ value = [], id, qaId, hasError, updateValue }) => (
        <Checkboxes
          id={id}
          name={name}
          getValue={optionName => value.includes(optionName)}
          hasError={hasError}
          onChange={option => update({ value, option, updateValue })}
          data-qa-id={qaId}
          large={large}
          getQaId={checkboxName => checkboxName}
          {...props}
        />
      )}
    />
  );
};

export default MultiCheckboxField;
